import fp from 'lodash/fp'
import {
  combine,
  withEffect,
  withCallbacks,
  withStateHandlers,
} from 'react-hooks-combine'

import SmartImageComponent from './component'

export default combine({
  defaultProps: {
    extension: 'png',
  },

  transformPropsBefore: fp.flow(
    fp.pick([
      'name',
      'source',
      'rounded',
      'alt',
      'extension',
      'className',
      'renderImageError',
      'renderImageLoader',
      'style',
    ]),
    ({ source, name, extension, ...props }) => {
      let possibleSource = source

      if (!source) {
        possibleSource = `./img/${name}.${extension}`
      }

      return {
        source: possibleSource,
        ...props,
      }
    }
  ),

  hooks: [
    withStateHandlers(
      {
        loading: true,
        crashed: false,
      },
      {
        setState: ({ args: [state] }) => state,
      }
    ),

    withEffect(
      ({ crashed, setState }) => {
        if (crashed) {
          setState({ crashed: false })
        }
      },
      ['source']
    ),

    withCallbacks(
      {
        onLoad:
          ({ setState }) =>
          () => {
            setState({ loading: false })
          },

        onError:
          ({ setState }) =>
          () => {
            setState({ loading: false, crashed: true })
          },
      },
      []
    ),
  ],
})(SmartImageComponent)
